/**
 * DateTime Showcase Page
 *
 * Demonstrates date and time widgets:
 * - Date picker
 * - Time picker
 * - DateTime picker
 * - Date range picker
 *
 * Route: /apps/examples/forms/datetime-showcase
 * API: /v2/api/formsexamples/rul/forms/datetime_showcase
 */

import { message } from 'antd';
import { UniversalRULForm } from '@/components/features/rul/UniversalRULForm';
import './DateTimeShowcasePage.css';

export const DateTimeShowcasePage: React.FC = () => {
  const handleSuccess = (data: any) => {
    message.success('Form validated successfully!');
    console.log('Form submitted:', data);
  };

  const handleError = (errors: Record<string, string>) => {
    message.error('Please fix validation errors');
    console.error('Validation errors:', errors);
  };

  return (
    <div className="datetime-showcase-page">
      <div className="datetime-showcase-container">
        <UniversalRULForm
          formUrl="/formsexamples/rul/forms/datetime_showcase"
          onSuccess={handleSuccess}
          onError={handleError}
          className="datetime-showcase-form"
          debounceMs={500}
        />
      </div>
    </div>
  );
};
